import React, { useEffect, useState } from "react";

import Modal from "../Modal";
import ModalFooterCloseBtn from "../ModalFooterCloseBtn";
import ModalProPromo from "../ModalProPromo";
import Toast from "../Toast";
import { CLOZE_MODE } from "../Stories/storiesEvents";
import useSaveStoryWord from "../Stories/useSaveStoryWord";

const SAVE_BUTTON_SELECTOR = "#translation-popover .sentence-search.btn";

export default function ClozeTextSaveToLearn({ isPro, quickCaptureEntriesUrl, storyId }) {
  const [isProPromoVisible, setIsProPromoVisible] = useState(false);
  const { saveWord, toast } = useSaveStoryWord({
    eventProperties: { mode: CLOZE_MODE, story_id: storyId },
    isPro,
    quickCaptureEntriesUrl,
    onProRequired: () => setIsProPromoVisible(true)
  });

  useEffect(() => {
    const saveSelection = (event) => {
      event.preventDefault();
      const selection = $("#translation-popover").find(".selection").text().trim();
      $(".sentence.popovered").popover("destroy").removeClass("highlight");
      saveWord(selection);
    };
    $("body").on("click", SAVE_BUTTON_SELECTOR, saveSelection);
    return () => $("body").off("click", SAVE_BUTTON_SELECTOR, saveSelection);
  }, [saveWord]);

  return (
    <>
      {!!toast && <Toast content={toast.content} context={toast.context} key={toast.id} maxWidth={300} />}
      {isProPromoVisible && (
        <Modal footer={<ModalFooterCloseBtn />} title="Pro Feature" onHidden={() => setIsProPromoVisible(false)}>
          <ModalProPromo can="save words from stories to learn later." />
        </Modal>
      )}
    </>
  );
}
